<template>
  <div>
    <Row class="margin-top-10">
      <Table :loading="loading" border :columns="columns" :data="data" ref="table"></Table>
    </Row>
    <Row class="margin-top-10">
      <Page
        :total="meta.total"
        :current="meta.current"
        show-total
        :page-size="meta.pageSize"
        @on-change="changePage"
      ></Page>
    </Row>
  </div>
</template>

<script>
export default {
  props: ['changePage', 'loading', 'data', 'columns', 'meta', 'onRowClick'],
  data() {
    return {}
  },
  computed: {}
}
</script>

<style lang="less" scoped>
.margin-top-10 {
  margin-top: 10px;
}
</style>
